import React, { useState, useEffect } from "react";

import DroppableTeamArea from "./droppableTeamArea";
import useWindowDimensions from "../../../utils/useWindowDimensions";

const GroupPicker = ({
  groups,
  onDrop,
  onReorder,
  isLocked,
  groupMatches,
  highlight,
  competition,
  availableWidth,
  compact,
}) => {
  const { width } = useWindowDimensions();
  const [groupMaps, setGroupMaps] = useState([]);

  useEffect(() => {
    // set number of groups displayed per row
    // 300 pixels needed per group
    let groupsPerRow = Math.floor((availableWidth || width) / 350) || 1;
    const keys = Object.keys(groups);
    let maps = [];
    let i = 0;
    while (i < keys.length) {
      maps.push(keys.slice(i, groupsPerRow + i));
      i += groupsPerRow;
    }
    setGroupMaps(maps);
  }, [width, availableWidth, groups]);

  return (
    <>
      {!isLocked && (
        <p className="text-center">
          Rearrange the teams by dragging and dropping or using the arrow
          buttons. The position of the teams in their groups will effect where
          they will be placed in the bracket. Changing the group order after you
          have already made selections in the bracket will cascade those changes
          through the whole bracket.
        </p>
      )}
      <div>
        {groupMaps.map((h, i) => (
          <div
            className="row"
            key={i}
            style={{ gridTemplateColumns: `repeat(${h.length}, 1fr)` }}
          >
            {h.map((g, ii) => {
              const groupMatrix = competition.groupMatrix
                ? competition.groupMatrix.find((m) => m.key === g)
                : null;
              return (
                <div key={ii} style={{ gridColumn: ii + 1 }}>
                  <DroppableTeamArea
                    groupHeader={
                      groupMatrix && g === groupMatrix.key
                        ? groupMatrix.name
                        : `Group ${g}`
                    }
                    description={
                      groupMatrix && g === groupMatrix.key
                        ? groupMatrix.description
                        : ""
                    }
                    groupName={g}
                    teams={groups[g]}
                    onDrop={onDrop}
                    onReorder={onReorder}
                    isLocked={isLocked}
                    matches={groupMatches ? groupMatches[g] : null}
                    highlight={highlight}
                    compact={compact}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </>
  );
};

export default GroupPicker;
